import React, { useState, useEffect } from 'react'; // Import React and hooks
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom'; // Importing routing components
// Importing components
import HeaderAuth from './Components/Headers/HeaderAuth';
import Home from './Components/Menu/Home';
import FinancesMenu from "./Components/Menu/FinancesMenu";
import Events from './Components/Menu/Events';
import SignIn from './Components/Controllers/SignIn';
import Inventory from './Components/Menu/Inventory';
import AddProduct from './Components/Interface/Inventory/AddProduct';
import Services from './Components/Menu/Services';
import AddService from './Components/Interface/Services/AddService';
import ModifyServices from './Components/Interface/Services/ModifyServices';
import Billing from './Components/Menu/Billing';
import BillingServiceController from './Components/Controllers/BillingServiceController';
import Calendars from './Components/Menu/Calendars';
import BirthdaysCalendar from './Components/Interface/Calendar/BirthdaysCalendar';
import DressReturnProcessor from './Components/Interface/Inventory/DressReturnProcessor';
import InventoryItems from './Components/Interface/Inventory/InventoryItems';
import ViewClosestEvents from './Components/Interface/Events/ViewClosestEvents';
import ViewEvents from './Components/Interface/Events/ViewEvents';
import ViewEventList from './Components/Interface/Events/ViewEventsList';
import ViewEventDetails from './Components/Interface/Events/ViewEventDetails';
import ViewPendingPicturesConfirmation from './Components/Interface/Events/ViewPendingPicturesConfirmation';
import ViewBirthdayList from './Components/Interface/Events/ViewBirthdayList';
import EventsCalendar from './Components/Interface/Events/EventsCalendar';
import ReservationController from './Components/Controllers/ReservationController';
import Clients from './Components/Menu/Clients';
import ViewClients from './Components/Interface/Clients/ViewClients';
import ViewPendingInvoices from './Components/Interface/Invoices/ViewPendingInvoices';
import ViewBirthday from './Components/Interface/Events/ViewBirthday';
import ViewInvoice from './Components/Interface/Invoices/ViewInvoice';
import ViewInvoicesList from './Components/Interface/Invoices/ViewInvoicesList';
import InvoiceReport from './Components/Interface/Invoices/InvoiceReport';
import DailyPaymentsReport from './Components/Interface/Invoices/DailyPaymentReport';
import MonthlyPaymentReport from './Components/Interface/Invoices/MonthlyPaymentReport';
import AnnualPaymentReport from './Components/Interface/Invoices/AnnualPaymentReport';
import ResetPasswordVerificationCode from './Components/Controllers/ResetPasswordVerificationCode';
import ChangePasswordController from './Components/Controllers/ChangePasswordController';
import Admin from './Components/Menu/Admin';
import Dashboard from './Components/Interface/Dashboard/Dashboard';
import CreateUsers from './Components/Interface/Dashboard/CreateUsers';
import CreditNoteView from './Components/Interface/Invoices/CreditNoteView';
import DebitNoteView from './Components/Interface/Invoices/DebitNoteView';
import ListDebitNotes from './Components/Interface/Invoices/ListDebitNotes'
import ListCreditNotes from './Components/Interface/Invoices/ListCreditNotes';
import RefreshPasswordOnFirstLogin from './Components/Controllers/RefreshPasswordOnFirstLogin';
import ModifyUsers from './Components/Interface/Dashboard/ModifyUsers';
import SuitReturnProcessor from './Components/Interface/Inventory/SuitReturnProcessor';
import AddServiceType from './Components/Interface/Services/AddServiceType';
import InternalCashFlowManager from './Components/Interface/Finances/InternalCashFlowManager';
import DailyCashReport from './Components/Interface/Finances/DailyCashReport'
import ViewEventsList from './Components/Interface/Events/ViewEventsList';

function App() {

  // State variables
  const [viewSection, setViewSection] = useState(0);
  const [prettyCashIsOpen, setPrettyCashIsOpen] = useState(false);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [validateUser, setValidateUser] = useState(false);
  const [dressList, setDressList] = useState([]);
  const [suitList, setSuitList] = useState([]);
  const [employee, setEmployee] = useState(() => {
    const storedEmployee = localStorage.getItem('employee');
    return storedEmployee ? JSON.parse(storedEmployee) : null;
  });

  const location = useLocation(); // Get the current location
  const navigate = useNavigate(); // Get the navigate function from react-router-dom

  const checkAuth = async () => {
    const url = location.pathname;
    if (url === '/sign-in' || url.startsWith('/reset-password/') || url.startsWith('/firstPasswordChange')) {
      setValidateUser(false);
      return;
    }
    const accessToken = token || localStorage.getItem('token');
    if (!accessToken) {
      setValidateUser(false);
      navigate('/sign-in');
      return;
    }

    if (!validateUser) {
      try {
        const response = await fetch('https://dprincess-training.servehttp.com/validate-user', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          },
        });

        if (response.status === 401 || response.status === 404) {
          localStorage.removeItem('token');
          setValidateUser(false);
          navigate('/sign-in');
        } else if (response.status === 403) {
          setValidateUser(false);
          navigate('/firstPasswordChange');
        } else {
          setValidateUser(true);
          setToken(accessToken)
        }
      } catch (error) {
        console.error('Error validating user:', error);
        setValidateUser(false);
        navigate('/sign-in');
      }
    }
  }

  const getDressList = async () => {
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/dress-inventories', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        return setDressList(data);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const getSuitList = async () => {
    try {
      const response = await fetch('https://dprincess-training.servehttp.com/suit-inventories', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (response.ok) {
        const data = await response.json();
        return setSuitList(data);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const getDressListHandler = () => {
    getDressList();
  };

  const getSuitListHandler = () => {
    getSuitList();
  };

  const handleViewSection = (section) => {
    return setViewSection(section)
  }

  const handleOpenPrettyCash = () => {
    return setPrettyCashIsOpen(true);
  };

  useEffect(() => {
    checkAuth();
    getDressList();
    getSuitListHandler();
  }, []);
  useEffect(() => {
    if (!token) {
      setToken(localStorage.getItem('token'));
    }
  }, [token]);
  useEffect(() => {
    const storedEmployee = localStorage.getItem('employee');
    if (storedEmployee) {
      const employee = JSON.parse(storedEmployee);
      setEmployee(employee);
    }
  }, []);
  useEffect(() => {
    if (employee) {
      const storedEmployee = localStorage.getItem('employee');
      const employee = JSON.parse(storedEmployee);
      return setEmployee(employee);
    }
    else {
      const storedEmployee = localStorage.getItem('employee');
      if (storedEmployee) {
        const employee = JSON.parse(storedEmployee);
        setEmployee(employee);
      }
    }
  }, []);

  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: '100vh' }}>
      {(location.pathname === '/sign-in' || location.pathname.startsWith('/reset-password/') 
        || location.pathname.startsWith('/firstPasswordChange')) ? null :
        <HeaderAuth handleViewSection={handleViewSection} handleOpenPrettyCash={handleOpenPrettyCash}
          prettyCashIsOpen={prettyCashIsOpen} viewSection={viewSection} token={token} employee={employee} />
      }
      <Routes>
        <Route path="/home" element={<Home employeeName={employee?.employeeName} />} />
        <Route path={`/firstPasswordChange`} element={<RefreshPasswordOnFirstLogin />} />
        {/* Rutas de los componentes de punto de finanzas --------------------------------------------------------------------------- */}
        <Route path={`/finances`} element={<FinancesMenu />} />
        <Route path={`/finances/cash-flow`} element={<InternalCashFlowManager />} />
        <Route path={`/finances/daily-cash-report`} element={<DailyCashReport />} />
        {/* Rutas de los componentes de inventario --------------------------------------------------------------------------- */}
        <Route path={`/inventory`} element={<Inventory />} />
        <Route path={`/inventory/add-item`} element={<AddProduct />} />
        <Route path={`/inventory/pending-items/dresses`} element={<DressReturnProcessor />} />
        <Route path={`/inventory/pending-items/suits`} element={<SuitReturnProcessor />} />
        <Route path={`/inventory/view-items`} element={<InventoryItems />} />
        {/* Rutas de los componentes de eventos --------------------------------------------------------------------------- */}
        <Route path={`/events`} element={<Events />} />
        <Route path={`/events/reservation-form-xv`} element={
          <ReservationController dressList={dressList} getDressListHandler={getDressListHandler}
            suitList={suitList} getSuitListHandler={getSuitListHandler} employee={employee}
          />
        }
        />
        <Route path={`/events/reservation-form-boda`} element={
          <ReservationController dressList={dressList} getDressListHandler={getDressListHandler}
            suitList={suitList} getSuitListHandler={getSuitListHandler} employee={employee}
          />
        }
        />
        <Route path={`/events/reservation-form-birthday`} element={
          <ReservationController dressList={dressList} getDressListHandler={getDressListHandler}
            suitList={suitList} getSuitListHandler={getSuitListHandler} employee={employee}
          />
        }
        />
        <Route path={`/events/events-full-calendar`} element={<EventsCalendar />} />
        <Route path={`/events/closest-events-list`} element={<ViewClosestEvents />} />
        <Route path={`/events/events-list`} element={<ViewEventsList token={token} />} />
        <Route path={`/events/view-event-details/:eventID`} element={<ViewEventDetails token={token} dressList={dressList}
          getDressListHandler={getDressListHandler} suitList={suitList} getSuitListHandler={getSuitListHandler} />}
        />
        <Route path={`/events/pending-confirmation`} element={<ViewPendingPicturesConfirmation token={token} />} />
        <Route path={`/events/birthday-list`} element={<ViewBirthdayList token={token} />} />
        {/* Rutas de los componentes de servicios --------------------------------------------------------------------------- */}
        <Route path={`/services`} element={<Services token={token} />} />
        <Route path={`/services/add-service`} element={<AddService token={token} />} />
        <Route path={`/services/modify-services`} element={<ModifyServices token={token} />} />
        <Route path={`/services/add-service-type`} element={<AddServiceType token={token} />} />
        {/* Ruta de componentes de Facturación ------------------------------------------------------------------------------------- */}
        <Route path={`/billing`} element={<Billing token={token} />} />
        <Route path={`/billing/services-billing`} element={
          <BillingServiceController employee={employee} token={token} dressList={dressList} getDressListHandler={getDressListHandler} 
          suitList={suitList} getSuitListHandler={getSuitListHandler} />
        } />
        <Route path={`/billing/pending-payments`} element={<ViewPendingInvoices token={token} />} />
        <Route path={`/billing/invoice/:invoiceID`} element={<ViewInvoice token={token} />} />
        <Route path={`/billing/issued-invoices`} element={<ViewInvoicesList token={token} />} />
        <Route path={`/billing/invoice-report`} element={<InvoiceReport token={token} />} />
        <Route path={`/billing/payment-report`} element={<DailyPaymentsReport token={token} />} />
        <Route path={`/billing/monthly-payment-report`} element={<MonthlyPaymentReport token={token} />} />
        <Route path={`/billing/annual-payment-report`} element={<AnnualPaymentReport token={token} />} />
        <Route path={`/billing/credit-note/:creditNoteId`} element={<CreditNoteView token={token} />} />
        <Route path={`/billing/debit-note/:debitNoteId`} element={<DebitNoteView token={token} />} />
        <Route path={`/billing/list-debit-notes`} element={<ListDebitNotes token={token} />} />
        <Route path={`/billing/list-credit-notes`} element={<ListCreditNotes token={token} />} />
        {/* Ruta de componentes de calendarios ---------------------------------------------------------------------------------------- */}
        <Route path={`/calendars`} element={<Calendars token={token} />} />
        <Route path={`/events/birthdays-full-calendar`} element={<BirthdaysCalendar token={token} />} />
        <Route path={`/events/birthday/:XVID`} element={<ViewBirthday token={token} />} />
        {/* Ruta de componentes de clientes ------------------------------------------------------------------------------------------------- */}
        <Route path={`/clients`} element={<Clients token={token} />} />
        <Route path={`/clients/manage-clients`} element={<ViewClients token={token} />} />
        {/* Ruta de componente de autorización ------------------------------------------------------------------------------------------------ */}
        <Route path='/sign-in' element={<SignIn />} />
        <Route path='/reset-password/check-verification-code' element={<ResetPasswordVerificationCode />} />
        <Route path='/reset-password/change-password' element={<ChangePasswordController />} />
        {/* Rutas de administración ------------------------------------------------------------------------------------------------ */}
        <Route path='/administration/dashboard' element={<Dashboard token={token} />} />
        <Route path='/administration' element={<Admin />} />
        <Route path='/administration/add-employees' element={<CreateUsers />} />
        <Route path='/administration/modify-employees' element={<ModifyUsers />} />
      </Routes>
    </div>
  );
}

export default App;
